import { select } from 'redux-saga/effects'
import * as locationSelectors from '../Location/selectors'
import * as selectors from './selectors'
import * as api from './api'
import getConstants from '../../constants'
import { DistanceUnit } from 'typings'

const CONSTANTS = getConstants()

const mapDistanceUnit: Record<DistanceUnit, string> = {
  km: 'km',
  mile: 'mi',
}

function* prepareSearchArgs(isLoadMore?: boolean): any {
  const geoCoordinates = yield select(locationSelectors.geoCoordinates)
  const radius = yield select(locationSelectors.radius)
  const filters = yield select(selectors.filters)
  const keyword = yield select(selectors.searchTerm)
  const areaCode = yield select(selectors.areaCode)
  const offset = yield select(selectors.offset)
  const states = yield select(selectors.states)
  const limit = yield select(locationSelectors.limit)

  // TODO
  // validate that there is either keyword or areaCode, or geo coordinates
  // before performing search
  const args: api.GetStoreListProps = {
    country: CONSTANTS.COUNTRY,
    limit,
    keyword,
    offset: isLoadMore ? offset : 0,
    filters,
    areaCode,
    ...geoCoordinates,
    maxDistance: radius,
    unitForDistance: mapDistanceUnit[CONSTANTS.DISTANCE_UNIT],
    states: states,
  }
  return args
}

export default prepareSearchArgs
